mutation SyncSageRecords(
  $syncSageAccounts: Boolean!
  $syncSageTransactions: Boolean!
  $matchTransactionRecords: Boolean!
) {
  syncSageRecords(
    input: {
      syncSageAccounts: $syncSageAccounts
      syncSageTransactions: $syncSageTransactions
      matchTransactionRecords: $matchTransactionRecords
    }
  ) {
    success
  }
}
